const defaultState = {
    positions: [],
    preferences: [],
    specialistsLeaves: {}
}

const SET_POSITIONS = "SET_POSITIONS"
const SET_PREFERENCES = "SET_PREFERENCES"
const SET_SPECISLISTS_LEAVES = "SET_SPECISLISTS_LEAVES"

export const specialistsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_POSITIONS:
            return { ...state, positions: action.payload }
        case SET_PREFERENCES:
            return { ...state, preferences: action.payload }
        case SET_SPECISLISTS_LEAVES:
            return { ...state, specialistsLeaves: action.payload }

        default:
            return state
    }
}

export const setPositionsAction = (payload) => ({ type: SET_POSITIONS, payload })
export const setPreferencesAction = (payload) => ({ type: SET_PREFERENCES, payload })
export const setSpecialistsLeavesAction = (payload) => ({ type: SET_SPECISLISTS_LEAVES, payload })